import {defineStore} from "pinia";

import AxiosClass from "@/classes/axios.js";
import General from "@/classes/general.js";
const axios = new AxiosClass();
const general = new General();

export const useThemeStore = defineStore('theme', {
    state: () => ({
        listOfThemes: [],
        logPageInfo: [],
        isLoading: false,
    }),
    getters: {
        currentTheme: (state) => {
            if (state.logPageInfo?.themeActive) {
                return (state.logPageInfo?.themeForce !== '')
                    ? state.logPageInfo.themeForce
                    : state.getCurrentSeasonComponent(state);
            }
        },
    },
    actions: {
        async getAllThemes() {
            this.isLoading = true;
            if (this.listOfThemes.length === 0) {
                await axios.get('/GetActiveThemes').then((response) => {
                    this.listOfThemes = response;
                });
            }
            await axios.get('/LogPageInfo').then((response) => {
                this.logPageInfo = {
                    themeActive: !!+response['THEME_LOGIN_ACTIVE']['value'],
                    themeForce: response['THEME_LOGIN_FORCE']['value'],
                    loginMethod: !!+response['MICROSOFT_LOGIN_METHOD']['value']
                }
            });
            this.isLoading = false;
        },
        getCurrentSeasonComponent(state = null) {
            const today = general.getToday();
            let themes = this.themes;
            if (state !== null) {
                themes = state.listOfThemes;
            }

            let currentTheme = {name: '', is_priority: 0};
            themes.forEach((theme) => {
                const dateTheme = general.setDate(theme.date, general.formatDate(undefined, 'YYYY'), 'year');
                const dateStart = (theme.week_before === 0)
                    ? general.getStartOfIsoWeek(dateTheme)
                    : general.getFromDate(dateTheme, 'subtract', theme.week_before, 'week');

                const dateEnd = (theme.week_after === 0)
                    ? general.getEndOfIsoWeek(dateTheme)
                    : general.getFromDate(dateTheme, 'add', theme.week_after, 'week');

                if (general.isDateBetween(today, dateStart, dateEnd, '[]') && currentTheme.is_priority !== 1) {
                    currentTheme = theme;
                }
            });

            return currentTheme.name;
        },
        clear () {
            this.$reset();
        },
    },
    persist: {
        storage: sessionStorage,
        paths: ['listOfThemes', "logPageInfo"],
    },
})